module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-36-10f445d349d5787340f341b0aa2b3863.svg";